/*
 * Adyen payload is too large to be stored in cookies (4096 byte limit),
 * and it would add a non-negligible amount of data to *every* server-side request.
 * For this reason we can't rely on native cookie expiry functionality and have to handle it manually.
 *
 * In a future iteration it would be nice to store the data in the localstorage,
 * and the expiry in a cookie, so that we can access and redirect it on server-side.
 *
 * TODO: Move this information to documentation!!
 */

import type { Nullable } from '@/types/utils';

const ADYEN_PAYLOAD_EXPIRY_IN_HOURS = 12;

const isExpired = (storageValue: { expiry?: string }) => {
  if (storageValue?.expiry) {
    const expiry = new Date(storageValue.expiry);
    return expiry.getTime() <= new Date().getTime();
  }

  // Missing `expiry` property counts as expired to invalidate and update legacy values
  return true;
};

export function readAdyenPayload(mustBeForPaymentModeCode?: Nullable<string>) {
  const val = getFromLocalStorage(LOCAL_STORAGE_ADYEN_PAYLOAD);

  // If expired we automatically delete for convenience
  if (isExpired(val)) {
    deleteAdyenPayload();
    return undefined;
  }

  // In this check we don't delete anything to be able to check specific stored payment mode payloads
  if (mustBeForPaymentModeCode && val.paymentMode !== mustBeForPaymentModeCode) {
    return undefined;
  }

  return val.data;
}

export function writeAdyenPayload(data: Record<string, any>, paymentMode: string) {
  const expiry = new Date();
  expiry.setTime(expiry.getTime() + ADYEN_PAYLOAD_EXPIRY_IN_HOURS * 60 * 60 * 1000);

  saveToLocalStorage(LOCAL_STORAGE_ADYEN_PAYLOAD, { expiry: expiry.getTime(), data, paymentMode });
}

export function deleteAdyenPayload() {
  deleteFromLocalStorage(LOCAL_STORAGE_ADYEN_PAYLOAD);
}
